export const errMsg = {
  editSuccess: "수정되었습니다.",
  editError: "수정에 실패해였습니다.",
  addSuccess: "등록되었습니다.",
  addError: "등록에 실패해였습니다.",
  deleteSuccess: "삭제되었습니다.",
  deleteError: "삭제에 실패해였습니다.",

  signUp: {
    10023: () => [
      `비밀번호는 영문 대소문자, 숫자, 특수문자`,
      <br key="password" />,
      `조합이며, 8자리 이상입니다`,
    ],
    10000: () => [`이메일을 다시 확인해주세요`],
  },
  reSettingPassword: {
    success: () => [
      `비밀번호가 재설정 되었습니다.`,
      <br key="reSettingPassword" />,
      `다시 로그인해 주세요!`,
    ],
    error: "재설정에 실패하였습니다.",
  },
};
